import { jsx, jsxs } from "react/jsx-runtime";
import Button from "@mui/material/Button/index.js";
import { PatientCreditworthinessStatus } from "../../containers/patient-today-list/patient-today-list.types.js";
import { Tooltip, Container, Header, Title, Summary, SummaryItem, SummaryItemKey, SummaryItemValue, Footer } from "./credit-worthiness-tooltip.styles.js";
import "@mui/material";
import "@mui/material/styles";
const CreditWorthinessTooltip = (props) => {
  const titleContent = (props == null ? void 0 : props.title) || /* @__PURE__ */ jsx(
    CreditWorthinessTooltipContent,
    {
      creditWorthinessData: props == null ? void 0 : props.creditWorthinessData,
      labels: props.creditWorthinessLabels
    }
  );
  return /* @__PURE__ */ jsx(
    Tooltip,
    {
      ...props,
      title: titleContent,
      componentsProps: { tooltip: { sx: { backgroundColor: "transparent" } } },
      children: props.children
    }
  );
};
const formatAmount = (amount) => {
  if (!amount) {
    return "";
  }
  const formattedAmount = parseFloat(amount).toLocaleString("de-DE", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
  return `${formattedAmount} €`;
};
const CreditWorthinessTooltipContent = (props) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r;
  return /* @__PURE__ */ jsxs(Container, { status: (_a = props == null ? void 0 : props.creditWorthinessData) == null ? void 0 : _a.status, children: [
    /* @__PURE__ */ jsx(Header, { children: /* @__PURE__ */ jsx(Title, { variant: "Lato Emphasized 2", children: (_b = props.labels) == null ? void 0 : _b.creditWorthinessTitle }) }),
    /* @__PURE__ */ jsxs(Summary, { children: [
      /* @__PURE__ */ jsxs(SummaryItem, { children: [
        /* @__PURE__ */ jsxs(SummaryItemKey, { children: [
          (_c = props.labels) == null ? void 0 : _c.status,
          ":"
        ] }),
        /* @__PURE__ */ jsx(SummaryItemValue, { children: ((_d = props == null ? void 0 : props.creditWorthinessData) == null ? void 0 : _d.status) && ((_f = props.labels) == null ? void 0 : _f.statuses[(_e = props == null ? void 0 : props.creditWorthinessData) == null ? void 0 : _e.status]) || ((_h = (_g = props.labels) == null ? void 0 : _g.statuses) == null ? void 0 : _h[PatientCreditworthinessStatus.UNKNOWN]) })
      ] }),
      ((_i = props == null ? void 0 : props.creditWorthinessData) == null ? void 0 : _i.factoringCompany) && /* @__PURE__ */ jsxs(SummaryItem, { children: [
        /* @__PURE__ */ jsxs(SummaryItemKey, { children: [
          (_j = props.labels) == null ? void 0 : _j.factoringCompany,
          ":"
        ] }),
        /* @__PURE__ */ jsx(SummaryItemValue, { children: (_k = props == null ? void 0 : props.creditWorthinessData) == null ? void 0 : _k.factoringCompany })
      ] }),
      ((_l = props == null ? void 0 : props.creditWorthinessData) == null ? void 0 : _l.limit) && /* @__PURE__ */ jsxs(SummaryItem, { children: [
        /* @__PURE__ */ jsxs(SummaryItemKey, { children: [
          (_m = props.labels) == null ? void 0 : _m.limit,
          ":"
        ] }),
        /* @__PURE__ */ jsx(SummaryItemValue, { children: formatAmount((_n = props == null ? void 0 : props.creditWorthinessData) == null ? void 0 : _n.limit) })
      ] }),
      ((_o = props == null ? void 0 : props.creditWorthinessData) == null ? void 0 : _o.availableAmount) && /* @__PURE__ */ jsxs(SummaryItem, { children: [
        /* @__PURE__ */ jsxs(SummaryItemKey, { children: [
          (_p = props.labels) == null ? void 0 : _p.availableAmount,
          ":"
        ] }),
        /* @__PURE__ */ jsx(SummaryItemValue, { children: formatAmount((_q = props == null ? void 0 : props.creditWorthinessData) == null ? void 0 : _q.availableAmount) })
      ] })
    ] }),
    (props == null ? void 0 : props.onOpenCreditWorthinessRequest) && /* @__PURE__ */ jsx(Footer, { children: /* @__PURE__ */ jsx(Button, { variant: "borderless", onClick: props == null ? void 0 : props.onOpenCreditWorthinessRequest, children: (_r = props.labels) == null ? void 0 : _r.requestCreditWorthinessCheck }) })
  ] });
};
export {
  CreditWorthinessTooltip,
  CreditWorthinessTooltipContent
};
